<template>
  <div class="fees-container">
    <div class="action-header">
      <!--<el-button type="primary" @click="handleAdd">添加会费</el-button>-->
    </div>
    <el-table
      :data="list"
      style="width: 100%">
      <el-table-column
        label="会员类型"
        prop="title">
      </el-table-column>
      <el-table-column
        label="注册费用"
        prop="regist">
      </el-table-column>
      <el-table-column
        label="保险费用"
        prop="insurance">
      </el-table-column>
      <el-table-column
        label="总计费用"
        :formatter="formatTotal"
        prop="totalFees">
      </el-table-column>
      <el-table-column
        label="更新时间"
        width="140"
        :formatter="formatDate"
        prop="updateDate">
      </el-table-column>
      <el-table-column
        label="状态"
        :formatter="formatState"
        prop="status">
      </el-table-column>
      <el-table-column
        label="操作"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <!--<el-button-->
            <!--size="mini"-->
            <!--type="danger"-->
            <!--@click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="编辑会费信息" center>
      <el-form :model="dialogForm" :rules="rules"  ref="dialogForm" class="modal" label-width="100px">
        <el-form-item label="会员类型" prop="name">
          <el-input v-model="dialogForm.title" readonly/>
        </el-form-item>
        <el-form-item label="注册费用(¥)" prop="regist">
          <el-input v-model.number="dialogForm.regist"/>
        </el-form-item>
        <el-form-item label="保险费用(¥)" prop="insurance">
          <el-input v-model.number="dialogForm.insurance" />
        </el-form-item>
        <el-form-item label="总计费用(¥)">
          <el-input readonly v-model="totalFees" type="number" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="dialogForm.status">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="-1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>
import * as moment from 'moment'
import { getFeesList, updateFees } from '@/api/site'
import { parseState } from '@/utils'
import cloneDeep from 'lodash/cloneDeep'

  const defaultForm = {
    status: 0
  }

  export default {
    name: 'Fees',
    data() {
      return {
        list  : [],
        dialogForm: {},
        listLoading: true,
        dialogVisible: false,
        formLabelWidth: '120px',
        rules: {
          regist: [
            { required: true, type:'number', message: '请输入数字', trigger: 'blur' }
          ],
          insurance: [
            { required: true, type:'number', message: '请输入数字', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      totalFees() {
          return this.dialogForm.regist + this.dialogForm.insurance
      }
    },
    created() {
      this.getList()
    },
    methods: {
      handleAdd() {
        this.dialogVisible = true
        this.isEditMode = false
        this.modalTitle = '添加会费信息'
        this.dialogForm = defaultForm
      },
      handleEdit(index, row) {
        this.dialogVisible = true
        this.isEditMode = true
        this.dialogForm = cloneDeep(this.list[index])
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.updateFees()
          } else {
            return false
          }
        });
      },
      getList() {
        this.listLoading = true
        getFeesList({admin: 1}).then(response => {
          const data = response.data
          this.list = data.list
          this.listLoading = false
        })
      },
      updateFees() {
        const data = {
          id: this.dialogForm.id,
          title: this.dialogForm.title,
          regist: this.dialogForm.regist,
          insurance: this.dialogForm.insurance,
          status: this.dialogForm.status
        }
        updateFees(data).then(response => {
          const data = response.data
          if(data) {
            this.$message({
              message: '更新成功',
              type: 'success',
              showClose: true,
              duration: 1000
            })
            this.getList()
          }
        })
      },
      formatTotal: function(row, column) {
        return row['insurance'] + row['regist'];
      },
      formatState: function(row, column) {
        const value = row[column.property];
        return parseState(value)
      },
      formatDate: function(row, column) {
        const date = row[column.property];
        return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .fees-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }

    /* dialog modal start */
    .el-dialog {
      width: 540px;
      .el-form-item {
        .el-input {
          width: 300px;
        }
      }
    }
    /* dialog modal end*/
  }
</style>
